import { useState } from "react";
import { CaretDown, CaretUp } from "phosphor-react";

const livefeedBackgroundColors = {
    "CLAIM": "rgba(146, 91, 255, 0.5)",
    "APPROVE": "rgba(36, 86, 51, 0.5)",
    "ABORT": "rgba(244, 67, 54, 0.5)",
    "IMAGE": "rgba(255, 142, 81, 0.5)",
}

  
const LiveFeedItem = ({element, id, hasBackground}) => {
    const [showImage, setShowImage] = useState(false);
    return (
        <div onClick={() => setShowImage(!showImage)} className="livefeedItem" style={{backgroundColor: livefeedBackgroundColors[element.type]}} >
            <div className="livefeedItemTextContainer">
                <div className="livefeedItem-arrow-and-text">
                    {element.imageUrl && !showImage && 
                        <CaretDown size={20} />
                    }
                    {element.imageUrl && showImage && 
                        <CaretUp size={20} />
                    }
                    <div className="livefeedItemText">{element.text}</div>
                </div>
                <div className="timestamp">{new Date(element.timestamp).toString().split(" ")[4].slice(0,5)}</div>
            </div>
            {element.imageUrl && showImage && (
                <img
                    className="livefeedImage"
                    src={element.imageUrl}
                    alt="Uploaded Images"
                    style={{width: "100%"}}
                />
            )}
        </div>
  );
};

export default LiveFeedItem;
